import { render } from "./ChristmasOfferRibbon.vue?vue&type=template&id=66fcd19e&scoped=true"
const script = {}

import "./ChristmasOfferRibbon.vue?vue&type=style&index=0&id=66fcd19e&lang=scss&scoped=true"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66fcd19e"],['__file',"src/components/christmas-offer/ChristmasOfferRibbon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "66fcd19e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('66fcd19e', __exports__)) {
    console.log('reload')
    api.reload('66fcd19e', __exports__)
  }
  
  module.hot.accept("./ChristmasOfferRibbon.vue?vue&type=template&id=66fcd19e&scoped=true", () => {
    console.log('re-render')
    api.rerender('66fcd19e', render)
  })

}


export default __exports__